import { connectionType, effectiveConnectionType } from './network-information';
import { isIos } from './environment-utils';

export function getEffectiveConnectionType(): string {
  return window.navigator &&
    window.navigator.connection &&
    window.navigator.connection.effectiveType
    ? window.navigator.connection.effectiveType.toUpperCase()
    : 'unknown';
}

export function getConnectionType(): string {
  return window.navigator &&
    window.navigator.connection &&
    window.navigator.connection.type
    ? window.navigator.connection.type.toUpperCase()
    : connectionType.WIFI;
}

/**
 * iOS does not support the EffectiveType API. Return true for iOS
 */
export const hasGoodEffectiveConnection = (): boolean => {
  if (isIos()) {
    return true;
  }
  return getEffectiveConnectionType() === effectiveConnectionType.FOURG;
};
